<template>
  <section class="nav">
    <div class="nav-spacer" />
    <div class="nav-slider">
      <div class="nav-slider-content">
        <div class="nav-slider-content-items">
          <NavigationButtonLibrarySlider
            v-for="content in orderedList"
            :key="content.id"
            :content="content"
            :size="size"
            :single-line="true"
            :type="type"
          />
          <NavigationButtonEdit v-if="addSettings" />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
interface Props {
  disabled?: boolean;
  addSettings?: boolean;
  size?: 'small' | 'normal' | 'medium';
  variant?: 'tonal' | 'outlined';
  type?: 'default' | 'statistics' | 'nomad';
}

defineProps({
  disabled: { type: Boolean, default: false },
  addSettings: { type: Boolean, default: true },
  size: { default: 'small' },
  variant: { default: 'tonal' },
  type: { default: 'default' }
});

const { contentUserTypeFromRoute } = useContentRouteHelper();

const { orderedList } = useContentsForUserType(contentUserTypeFromRoute.value);
</script>

<style lang="scss" scoped>
.nav {
  --height: 6rem;

  position: relative;
  top: calc(-1 * var(--row_gap));
  left: calc(-1 * var(--gap_n));
  width: calc(100% + 2 * var(--gap_n));
  height: calc(var(--height) - var(--gap_l));
  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(var(--height));
  }
  &::after {
    z-index: 0;
    height: calc(var(--height));
    background-color: var(--color_neutral_25);
  }
  &::before {
    z-index: 0;
    top: calc(var(--height) - 1rem);
    height: 1rem;
    box-shadow: rgb(99 99 99 / 10%) 0 0 8px 0;
  }

  @include above('l') {
    left: 0;
    width: 100%;
  }
}

.nav-spacer {
  width: 100%;
  height: 6rem;
}

.nav-slider {
  display: flex;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 6rem;
  overflow: hidden;
}

.nav-slider-content {
  display: inline-flex;
  position: relative;
  justify-content: flex-start;
  width: 100%;

  // height: 100%;

  height: 9rem;
  overflow: visible;
  overflow-x: scroll;
  @include scrollbars(3rem, var(--color_neutral_0), var(--color_neutral_0));

  &::before {
    content: '';
    display: inline-block;
    flex: 0 0 auto;
    width: var(--gap_n);
    background: transparent;
    @include above('l') {
      display: none;
    }
  }

  &-items {
    display: flex;
    height: 6rem;
    &::after {
      content: '';
      display: inline-block;
      flex: 0 0 auto;
      width: var(--gap_n);
      background: transparent;
      @include above('l') {
        display: none;
      }
    }
  }
}
</style>
